import { render, staticRenderFns } from "./DefaultDetailView.vue?vue&type=template&id=59c1df92"
import script from "./DefaultDetailView.js?vue&type=script&lang=js&external"
export * from "./DefaultDetailView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports